import { DocumentsActionTypes } from './constants';

type DocumentsAction = { type: string; payload: {} | string | Object };

// ------------------------------------
// Common API responses
// ------------------------------------
export const documentApiResponseSuccess = (actionType: string, data: any): DocumentsAction => ({
    type: DocumentsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const documentApiResponseError = (actionType: string, error: string): DocumentsAction => ({
    type: DocumentsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

// ------------------------------------
// Fetch actions
// ------------------------------------
export const getDocuments = (): DocumentsAction => ({
    type: DocumentsActionTypes.GET_DOCUMENTS,
    payload: {},
});

export const getDocument = (id: string): DocumentsAction => ({
    type: DocumentsActionTypes.GET_DOCUMENT,
    payload: { id },
});

export const getDocumentsByTransaction = (id: string): DocumentsAction => ({
    type: DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTION,
    payload: { id },
});

export const getDocumentsByTransactions = (ids: string[]): DocumentsAction => ({
    type: DocumentsActionTypes.GET_DOCUMENTS_BY_TRANSACTIONS,
    payload: { ids },
});

export const getDocumentsByListing = (id: string): DocumentsAction => ({
    type: DocumentsActionTypes.GET_DOCUMENTS_BY_LISTING,
    payload: { id },
});

export const getDocumentsByOwner = (owner: string): DocumentsAction => ({
    type: DocumentsActionTypes.GET_DOCUMENTS_BY_OWNER,
    payload: { owner },
});

// ------------------------------------
// Mutations
// ------------------------------------
export const createDocument = (id: string, data: Object): DocumentsAction => ({
    type: DocumentsActionTypes.CREATE_DOCUMENT,
    payload: { id, data },
});

export const updateDocument = (id: string, data: Object): DocumentsAction => ({
    type: DocumentsActionTypes.UPDATE_DOCUMENT,
    payload: { id, data },
});

export const deleteDocument = (id: string): DocumentsAction => ({
    type: DocumentsActionTypes.DELETE_DOCUMENT,
    payload: { id },
});